import React, { useState, useEffect }  from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import FormulaUtilsTooling from '../../../../tooling/formulaUtilsTooling';
import FormatTooling from '../../../../tooling/formatTooling';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import Constants from '../../../../definitions/constants';
import EngineFunctionsDefinition from '../../../../definitions/engineFunctionsDefinition';

import FunctionParamsEditor from './objectInputs/functionParamsEditor';
import TextBox from '../../common/inputs/textBox';
import Select from '../../common/inputs/select';

const FormulaFunctionEditor = props => {
  const {
    metricsList,
    marksList,
    entity,
    entityOptions,
    calendarsList,
    onChange,
    handleGoToEditFormula,
    handleDeleteEntity,
    escBehaviourHandler,
    onMarkEditorExitHandler,
    disabled,    
  } = props;
  let functionDefinition = (entity.name in EngineFunctionsDefinition.functionsList) ? EngineFunctionsDefinition.functionsList[entity.name] : null;
  if(entity.name == Constants.formulaEditor.markCode) {
    return (
      <div className="formula_editor_editor_entity_wrapper">
        <div className="formula_editor_editor_entity_label">
          {intl.formatMessage({id:"polynomialAdmin.formulaEditor.typeName.MARK"}) + ":"}
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            data-path="mark_name"
            value={entity.mark_name}
            onChange={onChange}
            className={(!entity.mark_name) ? " has_error" : null}
            dataType={Constants.formulaEditor.dataTypesTextBox.ID_CODE}
            labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.markNameLabel"/>}
            onKeyEnter={onMarkEditorExitHandler}
            disabled={disabled}
          />
          <i class="fas fa-save" onClick={onMarkEditorExitHandler} />
          {!disabled && (<span className="simulated-a" onClick={handleDeleteEntity}><FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.deleteEntity"/></span>)}
        </div>
      </div>
    );     
  }
  if(!functionDefinition) {
    return null;
  }
  let sumxMetricOptions = entityOptions.sumxMetricsNamesOptions;
  let colxMetricSelected = null;
  let dimensionOrValueOptions = null;
  let attributesObjectOptions = null;  
  let selectedAttribute = null;
  let functionParams = entity.childs.map((item,i) => {
    let value = "";
    let paramType = (i<functionDefinition.params.length) ? functionDefinition.params[i].type : null;
    let paramLabel = (i<functionDefinition.params.length) ? functionDefinition.params[i].label : null;
    let paramFormat = (i<functionDefinition.params.length) ? functionDefinition.params[i].format : null;
    let optionalFormulaOverrideString = (i<functionDefinition.params.length) ? functionDefinition.params[i].optionalFormulaOverrideString : null;    
    let allowEmpty = (i<functionDefinition.params.length) ? functionDefinition.params[i].allowEmpty : null;
    let optional = false;
    let logicFunction = "";
    let rightLogicalOverrideString = "";
    let options_list = null;
    let options_to_set_dimension_list = null;
    
    // set param type for cases where de param is optional
    if(paramType==null && functionDefinition.enableAddParams) {
      paramType = functionDefinition.addParamsType;
      optional = true;
    }
    else if(paramType==null) {
      return null;
    }
    
    // set value dependeing the param type and content types
    if(item.content && item.content.length>0 && 
       (paramType==Constants.formulaEditor.functionParamsTypes.metricsList ||
        (paramType==Constants.formulaEditor.functionParamsTypes.metricDimensionsOrValueList && item.type!=Constants.selectKeys.formulaEditor.formulaParamTypes.METRIC_VALUE) ||
        paramType==Constants.formulaEditor.functionParamsTypes.metricObjectAttributesList ||
        paramType==Constants.formulaEditor.functionParamsTypes.string ||
        (paramType==Constants.formulaEditor.functionParamsTypes.formula && optionalFormulaOverrideString && item.type==Constants.selectKeys.formulaEditor.formulaParamTypes.STRING))) {
      value = item.content[0];
    }
    else if(paramType==Constants.formulaEditor.functionParamsTypes.metricDimensionsOrValueList && 
            item.type==Constants.selectKeys.formulaEditor.formulaParamTypes.METRIC_VALUE && colxMetricSelected) {
      value = colxMetricSelected.object_definition ? ",valueobject," : ",value,"
    }
    else if(paramType==Constants.formulaEditor.functionParamsTypes.logicalFormula || paramType==Constants.formulaEditor.functionParamsTypes.logicalDimensionFormula) {
      value = item.content[0].comparator;
      logicFunction = item.content[0].is_function ? item.content[0].is_function : "";
      if(!item.content[0].is_function && item.content[0].childs && item.content[0].childs.length==2) {
        rightLogicalOverrideString = item.content[0].childs[1].type == Constants.selectKeys.formulaEditor.formulaParamTypes.STRING ? item.content[0].childs[1].content[0] : "";
      }
    }
    else if(paramType==Constants.formulaEditor.functionParamsTypes.optionsToSetDimension && 
        item.content && item.content.length>0 && item.type == Constants.selectKeys.formulaEditor.periodParamExtraType.HISTORIC_PERIODS) {
      value = item.content[0].period_limit
    }
    
    // set option_lists, metric, attributes or others
    if(paramType==Constants.formulaEditor.functionParamsTypes.metricsList) {
      options_list = sumxMetricOptions;
      colxMetricSelected = value ? metricsList.find(metric_item => metric_item.name == value) : null
      let sumxMetricOptionSelected = sumxMetricOptions ? sumxMetricOptions.find(sumxMetricOption => sumxMetricOption.label == value) : null;
      let is_calendar_virutal_metric = value == intl.formatMessage({id:"calendarAdmin.calendarMetricName"}) ? true : false
      if(!is_calendar_virutal_metric) {
        let is_calculation_metric = sumxMetricOptionSelected && sumxMetricOptionSelected.virtual_calculation;
        dimensionOrValueOptions = is_calculation_metric ?
          InterfaceTooling.getSelectArrayFromArray(sumxMetricOptionSelected.dimensionsNames) :
          InterfaceTooling.getSelectArrayFromArrayOfObjects(colxMetricSelected ? colxMetricSelected.dimension_hash : [], "name", "name");
        if(colxMetricSelected) {
          dimensionOrValueOptions.push({
            value: colxMetricSelected.object_definition ? ",valueobject," : ",value,",
            label: is_calculation_metric ? 
              intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.calculationParamValueLabel"}) : 
              intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues.metric_value"})
          });
        }
      }
      else {
        dimensionOrValueOptions = InterfaceTooling.getSelectArray("formulaEditor.entitiesAttributes.calendarDay","calendarAdmin.calendarMetricAttributes");
      }
    }
    else if(paramType==Constants.formulaEditor.functionParamsTypes.metricDimensionsOrValueList) {
      options_list = dimensionOrValueOptions;
      attributesObjectOptions = InterfaceTooling.getSelectArrayFromArrayOfObjects((colxMetricSelected && colxMetricSelected.object_definition) ? colxMetricSelected.object_definition : [], "name", "name")
    }
    else if(paramType==Constants.formulaEditor.functionParamsTypes.metricObjectAttributesList) {
      options_list = attributesObjectOptions;
    }
    else if(entity.name == EngineFunctionsDefinition.functionsList.MARKVALUE.code) {
      options_list = [{value:"", label: ""}].concat(Object.keys(marksList).sort().map(mark => {
        return {value: mark, label: mark};
      }));
    }
    else if(entity.name == EngineFunctionsDefinition.functionsList.ATTRIBUTE.code && i==0) {
      options_list = InterfaceTooling.getSelectArray("formulaEditor.entities","common.entities");
      selectedAttribute = value;
    }
    else if(entity.name == EngineFunctionsDefinition.functionsList.ATTRIBUTE.code && i==1 && selectedAttribute) {
      options_list = InterfaceTooling.getSelectArray("formulaEditor.entitiesAttributes." + selectedAttribute,"common.entities.attributes." + selectedAttribute);
    }
    else if(entity.name == EngineFunctionsDefinition.functionsList.ATTRIBUTE.code && i==1 && !selectedAttribute) {
      options_list = []
    }
    else if(entity.name == EngineFunctionsDefinition.functionsList.VALIDATEBYSYSTEMDIMENSION.code && i==0) {
      options_list = InterfaceTooling.getSelectArray("formulaEditor.entities","common.entities");
    }  
    else if(entity.name == EngineFunctionsDefinition.functionsList.EXTRACTDATE.code && i==1) {
      options_list = InterfaceTooling.getSelectArray("selectKeys.formulaEditor.extractDateTypes","polynomialAdmin.formulaEditor.functionOptions.extractDateTypesValues");
    }
    else if(entity.name == EngineFunctionsDefinition.functionsList.CALENDAR.code && i==3) {
      options_list = InterfaceTooling.getSelectArray("selectKeys.formulaEditor.calendarDayTypes","polynomialAdmin.formulaEditor.functionOptions.calendarDayTypesValues");
    }
    else if(entity.name == EngineFunctionsDefinition.functionsList.CALENDAR.code && i==0) {
      options_list = InterfaceTooling.getSelectArrayFromArrayOfObjects(calendarsList ? calendarsList : [], "id", "extended_name");
    }
    else if(entity.name == EngineFunctionsDefinition.functionsList.REDUCEX.code && i==2) {
      options_list = InterfaceTooling.getSelectArray("selectKeys.formulaEditor.reduceXTypes","polynomialAdmin.formulaEditor.functionOptions.reduceXTypes");
    }  
    else if(entity.name == EngineFunctionsDefinition.functionsList.ATTRIBUTE.code && i==2) {
      options_to_set_dimension_list = InterfaceTooling.getSelectArray("selectKeys.formulaEditor.optionsToSetDimensionTypes","polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues", false);
    }    
    else if(entity.name == EngineFunctionsDefinition.functionsList.INFOX.code && i==1) {
      options_list = InterfaceTooling.getSelectArray("selectKeys.formulaEditor.infoXTypes","polynomialAdmin.formulaEditor.functionOptions.infoXTypes");
    }
    else if(entity.name == EngineFunctionsDefinition.functionsList.DIMENSIONRANGE.code && i==0) {
      options_list = InterfaceTooling.getSelectArray("selectKeys.formulaEditor.dimensionRangeOperatorTypes","polynomialAdmin.formulaEditor.functionOptions.dimensionRangeOperatorTypes", false);
    }
    return {
      param_type: paramType,
      optional_formula_override_string: optionalFormulaOverrideString,
      allow_empty: allowEmpty,
      param_format: paramFormat,
      value: value,
      type: item.type,
      label: paramLabel,
      is_logic_function: logicFunction,
      right_logical_override_string: rightLogicalOverrideString,
      optional: optional,
      options_list: options_list,
      options_to_set_dimension_list: options_to_set_dimension_list
    }
  });

  let compareOptions = (entity.name == EngineFunctionsDefinition.functionsList.DIMENSIONRANGE.code) ? 
    InterfaceTooling.getSelectArray("selectKeys.formulaEditor.dimensionLogicalComparators","polynomialAdmin.formulaEditor.entityEditor.compareSelectValues", false) :
    InterfaceTooling.getSelectArray("selectKeys.formulaEditor.logicalComparators","polynomialAdmin.formulaEditor.entityEditor.compareSelectValues", false);

  let isLogicFunctionOptions = (entity.name == EngineFunctionsDefinition.functionsList.DIMENSIONRANGE.code) ?
    InterfaceTooling.getSelectArray("selectKeys.formulaEditor.isSpecialLogicFunctionOptions","polynomialAdmin.formulaEditor.entityEditor.isLogicDimensionSpecialFunctionValues") :
    InterfaceTooling.getSelectArray("selectKeys.formulaEditor.isSpecialLogicFunctionOptions","polynomialAdmin.formulaEditor.entityEditor.isLogicSpecialFunctionValues");

  return (
    <div className="formula_editor_editor_entity_wrapper">
      <div className="formula_editor_editor_entity_label">
        {intl.formatMessage({id:"polynomialAdmin.formulaEditor.typeName." + entity.type + (entity.is_table ? "T" : "")}) + ": " + functionDefinition.label}
        {!disabled && (<span className="simulated-a" onClick={handleDeleteEntity}><FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.deleteEntity"/></span>)}
      </div>
      <div className="formula_editor_editor_entity_inner">
        <div className="formula_editor_editor_entity_inner_left">
          <FunctionParamsEditor
            enableAdd={functionDefinition.addParamsType}
            addType={functionDefinition.addParamsType}
            addLabel={functionDefinition.addParamsLabel}
            addButtonLabel={functionDefinition.addParamsAddButtonLabel}
            addLimit={functionDefinition.addParamsLimit}
            paramsNumber={functionDefinition.params.length}
            compareOptions={compareOptions}
            isLogicFunctionOptions={isLogicFunctionOptions}
            values={functionParams}
            onChange={onChange}
            handleGoToEditFormula={handleGoToEditFormula}
            className={(functionParams.length==0 && entity.name != EngineFunctionsDefinition.functionsList.CANCELCALCULATION.code) ? " has_error" : null}
            disabled={disabled}
            escBehaviourHandler={escBehaviourHandler}
          />
        </div>
        {(entity.name == EngineFunctionsDefinition.functionsList.IFERROR.code) && (
          <div className="formula_editor_editor_entity_inner_right formula_editor_editor_entity_options">
            <Select
              className="formula_editor_editor_entity_option_if_error_type"
              data-path="error_type"
              value={entity.error_type ? entity.error_type : ""}
              onChange={onChange}
              labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.errorTypeLabel"/>}
              options={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.errorTypes","polynomialAdmin.formulaEditor.functionOptions.errorTypesSelect", true, intl.formatMessage({id:"polynomialAdmin.formulaEditor.functionOptions.errorTypesSelect.GENERAL"}))}
              disabled={disabled}
            />
          </div>
        )}
        {(entity.name == EngineFunctionsDefinition.functionsList.ROUND.code) && (
          <div className="formula_editor_editor_entity_inner_right formula_editor_editor_entity_options">
            <Select
              className="formula_editor_editor_entity_option_if_error_type"
              data-path="round_type"
              value={entity.round_type ? entity.round_type : ""}
              onChange={onChange}
              labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.roundTypeLabel"/>}
              options={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.roundTypes","polynomialAdmin.formulaEditor.functionOptions.roundTypesSelect", true, intl.formatMessage({id:"polynomialAdmin.formulaEditor.functionOptions.roundTypesSelect.DEFAULT"}))}
              disabled={disabled}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default FormulaFunctionEditor;



// WEBPACK FOOTER //
// ./source/client/components/formulaEditor/entityEditors/formulaFunctionEditor.jsx